
import React from "react";

export function HotlineListHeader() {
    return (
        <div className={"w-full"}>
            <div className="grid grid-cols-5 w-full gap-8">
                <div>Name</div>
                <div>Start</div>
                <div>End</div>
                <div>Active</div>
                <div>Actions</div>
            </div>
            <hr className={"mt-4 w-full"}/>
        </div>

    )
}